import * as yup from 'yup';

export const pyroCompanySchema = yup.object().shape({
	name: yup.string().required('Name is required.'),
	operator: yup.string().required('Operator is required.'),
	address: yup.string().required('Mailing address is required.'),
	city: yup.string().required('City is required.'),
	state: yup.string().required('State is required.'),
	phone: yup.string().required('Phone is required.'),
	//.matches(/\(?([0-9]{3})\)\s([0-9]{3})[-.●]?([0-9]{4})$/, 'Format: (xxx) xxx-xxxx'),
	zip: yup
		.string()
		.required('Zip Code is required.')
		.matches(/[0-9]{5}/g, 'Invalid Zip Code.'),
	license: yup.string().required('License number is required.'),
});
